<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>mupi</title>
    <path fill="#679940"
      d="M24.5,2a1,1,0,0,0-1-1H8.5a1,1,0,0,0-1,1V25s0,0,0,.07a1.29,1.29,0,0,0,0,.19,1.07,1.07,0,0,0,.07.19s0,0,0,.06l3,5a1,1,0,0,0,.86.49h9a1,1,0,0,0,.86-.49l3-5s0,0,0-.06a1.07,1.07,0,0,0,.07-.19,1.29,1.29,0,0,0,0-.19s0-.05,0-.07ZM19.93,29H12.07L9.5,24.72V3h13V24.72Z"
    />
    <path fill="#679940"
      d="M19.5,5h-7a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V6A1,1,0,0,0,19.5,5Zm-1,17h-5V7h5Z"
    />
  </svg>
</template>

<script>
export default {
  name: "MupiIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/MupiIcon.vue